

const CQ_AutoFillForm = (iniVal, vpData,transferData) => {
  console.log("auto", iniVal, vpData);

  console.log('date compa',typeof(vpData.Request.Proposal.Proposer.DateofBirth), typeof(vpData.Request.Proposal.LifeAssured.DateOfBirth))
   

  Object.entries(iniVal.primaryDetails).map(entry=>{
    if(vpData.Request.Proposal.hasOwnProperty(entry[0])){
     
      iniVal.primaryDetails[entry[0]]=vpData.Request.Proposal[entry[0]]
    }
    return null
  })


  Object.keys(iniVal.primaryDetails.Payment).forEach((k) => {
    iniVal.primaryDetails.Payment[k] = transferData.payment[k] ?? iniVal.primaryDetails.Payment[k];
    return null
  }); 
 
  iniVal = {
    ...iniVal,
    Proposer: vpData.Request.Proposal.Proposer,
    nomineeDetails : vpData.Request.Proposal.Nominee,
    pedQuestionnPrimary: vpData.Request.Proposal.Questions,
    primaryDetails:{
      ...iniVal.primaryDetails,
      Payment:{
        ...iniVal.primaryDetails.Payment,
        TransationAmount:vpData.Request.Proposal.Plan.TotalPremium
      }
    }
  }
  console.log("final ini", iniVal);
  return iniVal;
};

export default CQ_AutoFillForm;
